// extracted by mini-css-extract-plugin
export default {"fontSize":"DownloadProductionCodeRequestFile_fontSize__qbfKp"};